import ReactStrapTable from 'components/reactStrapTable';
import React, { useEffect, useState } from 'react'
import EditIcon from 'assets/icon/icon-icon-options-edit.svg';
import ConfigIcon from "assets/icon/config-setting-icon.svg";
import ConfigIconHover from "assets/icon/config-setting-icon-hover.svg";
import EditHoverIcon from 'assets/icon/icon-icon-options-edit_hover.svg';
import HoverImage from 'react-hover-image/build';
import { Button, ButtonGroup, Col, FormGroup, Input, InputGroup, InputGroupText, Label, Row } from 'reactstrap';
import { dateFormate, currencyFormat, cellRendererCheck } from 'utils/columns';
import CancleIcon from 'assets/icon/icon-icon-options-not-eligible.svg';
import Calendar from 'assets/icon/calendar-icon.svg';
import SaveIcon from 'assets/icon/icon-icon-options-order-complete.svg';
import CellEditRender from 'components/reactStrapTable/components/CellEditRender';
import CancleHoverIcon from 'assets/icon/icon-icon-options-not-eligible-hover.svg';
import SaveHoverIcon from 'assets/icon/icon-icon-options-order-complete-hover.svg';
import { Field, Formik } from 'formik';
import ReactSelect from 'react-select';
import FormikDatePicker from 'components/common/Fields/FormikDatePicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleUp, faL } from "@fortawesome/free-solid-svg-icons";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import Drawer from 'components/Drawer';
import { Option, LimitedChipsContainer } from 'components/Options';
import useAxios from 'hooks/useAxios';
import useContextService from 'hooks/useContextService';
import { ceil, clone, cloneDeep, iteratee } from 'lodash';
import { set } from 'lodash';
import NDCList from 'components/NDCList';
import { useAsync } from 'react-async';
import * as Yup from 'yup';

import reseticon from "assets/icon/reset.svg";
import search from "assets/icon/search.svg";
import configicon from "assets/icon/config-icon.svg";




let hasDatePopupOpen = false;



let coveredEntityError = 'Covered Entity Name is a required field';
let accumulatorError = 'Accumulator is a required field';
let rowForEdit = {};
let updatedFields = {};
let coveredEntitiesData = [];
let accumulationsData = [];
const validationSchema = Yup.object({
    //coveredEntityID: Yup.string().required('Please select covered entity'),
});

const SearchContainer = (props) => {
    const {
        states: { configurations },
        setStates,
        resetStates,
    } = useContextService();
        const [hasCESelected, setCESelected] = useState(true);
        const [selectedCEOption, setCEOptionSelected] = useState({ optionCESelected: '-1' });
        // const [loading, setLoading] = useState(false);
        const [isSubmited, serIsSubmitted] = useState(false);
         
        const { accumulations, coveredEntity, searchTerms } = configurations;
        let {
            coveredEntityIDs,
            coveredEntityID,

        } = searchTerms;
    const API = useAxios();
    
    const {  orgId, onSearch, onReset,setCEDId,CEDid,fetchcoveredentityDetails,CEflag, setCEflag,viewConfig,
    setviewConfig,
    setACCflag,setRowData,
    ACCflag,  AccumulatorTable,
    SetAccumulatorTable,rowData,setConfigFlag,
    configflag,setLoading,
    loading, resetFilterFlag,SetResetFilterFlag
                } = props;
    const updateStates = (configurations) => {
        setStates('configurations', configurations);
    };
      useEffect(() => {
            setCESelected(true);
            updateStates(configurations);
            coveredEntitiesData = [];
            configurations.searchTerms.coveredEntityIDs = {}
            setCEOptionSelected({ optionCESelected: '-1' });
            fetchCoveredEntities();
            serIsSubmitted(false);
        }, [orgId])
       
    const fetchCoveredEntities = async () => {
        //let { organizationID } = orgId;
        if (typeof orgId !== "undefined" && orgId !== null) {
            coveredEntitiesData = [];
            configurations.searchTerms.coveredEntityIDs = [];
            updateStates(configurations);

            let selectedOrgId = orgId.organizationID;

            setLoading(false);
            try {
                
                const { data } = await API.get(`SBConfig/coveredentity/list/${selectedOrgId}`, {
                    hasDefaultURL: true,
                });
                setLoading(false);
                if (data) {
                    for (var x in data) {
                        coveredEntitiesData.push({ "value": data[x].coveredEntityID, "label": data[x].coveredEntityName });
                    }
                    configurations.coveredEntities = data;
                    console.log(coveredEntitiesData[0],"coveredEntity")
                    // setCEDId(coveredEntitiesData[0].value)
                    // fetchcoveredentityDetails(coveredEntitiesData[0].value)


                    if (coveredEntitiesData.length == 1) {
                        var ceData = [];
                        ceData.push(coveredEntitiesData[0]);
                        configurations.searchTerms.coveredEntityIDs = ceData;
                        setCEDId(coveredEntitiesData[0].value)
                    }
                    if (coveredEntitiesData.length == 1) {
                        var ceData = [];
                        ceData.push(coveredEntitiesData[0])
                         configurations.searchTerms.coveredEntityIDs = ceData;
                         window.selectedCoveredEntittyId = ceData;
                    }
                    if (window.selectedCoveredEntittyId.length > 0) {
                         configurations.searchTerms.coveredEntityIDs = window.selectedCoveredEntittyId;
                         setCEDId(window.selectedCoveredEntittyId[0].value)
                        }

                    updateStates(configurations);
                    if (Array.isArray(configurations.searchTerms.coveredEntityIDs)) {

                        var ceSelected = [];
                        ceSelected.optionCESelected = [];
                        for (var x in configurations.searchTerms.coveredEntityIDs) {

                            ceSelected.optionCESelected.push(configurations.searchTerms.coveredEntityIDs[x]);
                        }
                        setCEOptionSelected(ceSelected);
                        let ceIds = configurations.searchTerms.coveredEntityIDs.map(item => item["value"]);
                    }

                }
            }
            catch (err) {
                setLoading(false);
            }
        }

    };
    const handleCoverdEntityChange = (selectedces, setFieldValue, entity) => {


        let selected = [selectedces == null ? []: selectedces]
    
            if (selected) {
                console.log(selected[0].value,"selected")

                 window.selectedCoveredEntittyId = selected;
                // accumulationsData = [];
                // setSelectedNdc('');
                // inventory.searchTerms.accumulationIDs = {};
                setCESelected(true);
                setCEOptionSelected({
                    optionCESelected: selected.value
                });
                let val = selected.value;
             configurations.coveredEntities = selected;
                 setFieldValue('coveredEntityIDs', selected);
                 configurations.searchTerms.coveredEntityIDs = selected;
                // if (Array.isArray(configurations.searchTerms.coveredEntityIDs)) {
                //     accumulationIDs = {};
                //     inventory.searchTerms.accumulationIDs = {};
                // }
                 let ceIds = configurations.searchTerms.coveredEntityIDs.map(item => item["value"]);
                configurations.searchTerms.coveredEntityIDs = ceIds;
                updateStates(configurations);
                setCEDId(selected[0].value)

                setConfigFlag(true)

                // fetchAccumulatorName(ceIds);
                // setAccuOptionSelected({ optionSelected: '-1' });
            }
            else {
                setFieldValue('coveredEntityIDs', {});
                // accumulationsData = [];
                 configurations.coveredEntities = [];
                configurations.searchTerms.coveredEntityIDs = {};
                // inventory.searchTerms.accumulationIDs = {};
                setCESelected(false);
                // setACSelected(false);
            }
            updateStates(configurations);
        };
         const handleSubmit = async (val, actions) => {
                 ;
                serIsSubmitted(true);
                const { setSubmitting } = actions;
                let acIDs = [];
                let ceIDs = [];
        
                if (searchTerms.coveredEntityIDs.length > 0) {
                    val.coveredEntityIDs = searchTerms.coveredEntityIDs;
                    setCESelected(true);
                }
             
              
                for (var x in val.coveredEntityIDs) {
                    var rw = val.coveredEntityIDs[x];
                    ceIDs.push(rw);
                    // ceIDs.push(rw.value);
                }
                 if (ceIDs.length > 0) values.coveredEntityIDs = ceIDs;
                if(ceIDs.length == 0){
                    setCESelected(false);
                } 
                setCEDId(coveredEntityIDs[0])

                fetchcoveredentityDetails(coveredEntityIDs[0])
                const values = cloneDeep(val);
                // if (ceIDs > [0]) values.coveredEntityIDs = val.coveredEntityIDs;
                // if (ceIDs > [0]) values.coveredEntityIDs = ceIDs;
        
             
                // if (showClaimID) {
                //     values.showClaimID = showClaimID;
                //     setSubmit(true);
                // }
        
                configurations.search.currentPage = 1;
                updateStates(configurations);
                await onSearch(values);
                setSubmitting(false);
            };
            const handleReset=()=>{
                 debugger
                setviewConfig(false)
                SetResetFilterFlag(true);
                setACCflag(false);
                setCEflag(false);
                setCEOptionSelected({ optionCESelected: '-1' });
                configurations.searchTerms.coveredEntityIDs = {};
                window.selectedCoveredEntittyId = "";
                searchTerms.coveredEntityIDs = [];
                setCEDId("")
                // onReset();
                setRowData([])
                SetAccumulatorTable([])
            }
  const handleviewConfig=()=>{
    setCEflag(true)
  }

    return (
        <div>

            <Formik
                initialValues={searchTerms}
                // initialValues={initialValues}
                 onSubmit={handleSubmit}
                validationSchema={validationSchema}
                enableReinitialize={true}
                children={(props) => {
                    const { isSubmitting, handleSubmit, resetForm, setFieldValue, errors, touched } = props;
                    return (
                      <div hidden={""}>
                        <div>
                          <div className="d-flex justify-content-between">
                            <h5 className="f-16 text-primary font-weight-700">
                              Search Covered Entity
                            </h5>
                            {/* <Button
                  // hidden={isAddPermission}
                  // disabled={isSubmitting}
                  onClick={handleviewConfig}
                //   onClick={""}
                  color="primary"
                  className="search"
                disabled={CEDid.length==0}
                >
                  <span className="right_5">
                    <img src={configicon} alt="" />
                  </span>{" "}
                  Configurations
                </Button> */}
                          </div>

                          <Row sm={5} className="d-flex" style={{}}>
                            <Col md={3} lg={3} sm={6} xs={6}>
                              {" "}
                              <FormGroup>
                                <Label for="coveredEntity">
                                  Covered Entity
                                </Label>
                                <ReactSelect
                                  name="coveredEntity"
                                  id="coveredEntity"
                                  options={coveredEntitiesData}
                                  //  isMulti
                                  // isOptionSelected={""}
                                  // closeMenuOnSelect={false}
                                  // hideSelectedOptions={false}
                                  // optionSelected={true}
                                  components={{
                                    Option,
                                  }}
                                  // isSearchable="true"
                                  onChange={(value, entity) =>
                                    handleCoverdEntityChange(
                                      value,
                                      setFieldValue,
                                      entity
                                    )
                                  }
                                  value={selectedCEOption.optionCESelected}
                                  className="claim_info required"
                                  // maxMenuHeight={220}
                                  styles={{
                                    menu: (provided) => ({
                                      ...provided,
                                      zIndex: 99,
                                    }),
                                    option: (provided) => ({
                                      ...provided,
                                      display: "flex",
                                      alignItems: "flex-start",
                                    }),
                                  }}
                                />
                                {!hasCESelected ? (
                                  <div className="text-danger f-12 position-absolute">
                                    {coveredEntityError}
                                  </div>
                                ) : null}
                              </FormGroup>
                            </Col>
                          </Row>
                        </div>
                        <div hidden={""}>
                          <Row
                            className="d-flex"
                            style={{ justifyContent: "flex-end" }}
                          >
                            <Col md="auto" className="">
                              <Label>{""}</Label>
                              <Button
                                // hidden={isAddPermission}
                                hidden={true}
                                // disabled={isSubmitting}
                                color="primary"
                                className="search ms-3"
                                onClick={handleSubmit}
                                // disabled={!coveredEntityid}
                                // hidden={!hasPermission("ADD")}
                              >
                                <span className="right_5">
                                  <img src={search} alt="" />
                                </span>{" "}
                                Search
                              </Button>
                              <Button
                                // hidden={isAddPermission}
                                // disabled={isSubmitting}
                                color="primary"
                                className="reset"
                                onClick={handleReset}
                                // disabled={!coveredEntityid}
                                // hidden={!hasPermission("ADD")}
                              >
                                <span className="right_5">
                                  <img src={reseticon} alt="" />
                                </span>{" "}
                                Reset
                              </Button>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    );
                }}></Formik>
            {/* <div className="py-2 text-center">
                <span style={{ fontSize: "27px", cursor: "pointer", }} onClick={toggleSider}>
                    <FontAwesomeIcon icon={collIcon} className="fa-fw" />
                </span>
            </div> */}



        </div>
    )
}

export default SearchContainer
